import { initializeApp } from 'firebase/app'
import ReactDOM from 'react-dom/client'
import { initiateSentry } from '~/services/sentry'
import '~/utils/polyfill'

import App from './app'
import './app.global.css'

initiateSentry()
const firebaseConfig = {
  apiKey: 'AIzaSyDXQGLkpcOH2zq4lBZRvVvyKub0YGK8ffQ',
  authDomain: 'mango-webapp.firebaseapp.com',
  projectId: 'mango-webapp',
  storageBucket: 'mango-webapp.appspot.com',
  messagingSenderId: '857484530292',
  appId: '1:857484530292:web:6b508d22764e03a3817721',
}

initializeApp(firebaseConfig)

const root = document.getElementById('root')
if (root) {
  ReactDOM.createRoot(root).render(<App />)
}
